import gql from 'graphql-tag';

// create a fragment for frequency
export const frequency = gql`
  fragment frequency on NotificationSubscription {
    frequency {
      value
      options {
        code
        label
        description
      }
    }
  }
`;
export const getPreferenceQL = gql`
  query GetPreference($locale: Locale) {
    viewer {
      id
      profileVisibility {
        level
      }
      notificationPreferenceGroups(locale: $locale) {
        category {
          code
          description
        }
        notificationPreferences {
          product {
            code
            label
            description
          }
          subscriptions {
            id
            channel {
              code
              label
            }
            subscribed
            ...frequency
          }
        }
      }
    }
  }
  ${frequency}
`;

export const updatePreferenceQL = gql`
  mutation UpdateNotificationSubscription(
    $input: NotificationPreferenceInput!
  ) {
    updateNotificationSubscription(input: $input) {
      subscriptions {
        id
        subscribed
        ...frequency
      }
    }
  }
  ${frequency}
`;

export const updateSubscriptionQL = gql`
  mutation UpdateNotificationSubscriptionWithToken(
    $input: NotificationPreferenceWithTokenInput!
  ) {
    updateNotificationSubscriptionWithToken(input: $input) {
      product {
        code
      }
      subscriptions {
        id
        subscribed
        channel {
          code
        }
      }
    }
  }
`;
